// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Actions
import { setFundChartSecuritylistName } from './security-list-name.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const securitylistName = createReducer('', on(setChartData, (state, { chartData }) => chartData.params.securitylistName), on(setFundChartSecuritylistName, (state, { securitylistName: newSecuritylistName }) => newSecuritylistName));
